/* Copyright (c) 2017 Backpack Health LLC */

/* global window */
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import Spacer from '../../../../components/Spacer';
import { Heading, Subheading } from '../../../../components/Text';
import { GroupThemeMarkdown, BackpackThemeMarkdown } from '../../../../components/Markdown';
import LegalDocumentLinks from '../../../../components/LegalDocumentLinks';
import PrivacyHeader from '../../../../components/PrivacyHeader';
import PolicyTextConnected from '../../../../components/PolicyText.connected';
import { PolicyName } from '../../../../../models/PolicyModel';

interface Props {
  hasLeadIn: boolean;
  noHeading: boolean;
  intl: any;
}

interface State {
  showFullLegal: boolean;
}

class GroupConsentText extends React.Component<Props, State> {

  state: State = {
    showFullLegal: false,
  };

  render() {
    const { hasLeadIn, noHeading } = this.props;
    const { intl } = this.props;
    const { locale: languageCode } = intl;

    return (
      <div>
        {
          !noHeading &&
            <div>
              <PrivacyHeader />
              <Spacer size="9" />
              <Heading>
                <FormattedMessage id="groupJoinConsent.heading.text" />
              </Heading>
            </div>
        }


        {
          hasLeadIn ? (
            <div>
              <Spacer size="5" />
              <PrivacyHeader />
              <Spacer size="18">
                <Heading>
                  <FormattedMessage id="groupJoinConsent.summaryLeadIn.text" />
                </Heading>
              </Spacer>
            </div>
          ) : <Spacer size="10" />
        }

        <Subheading>
          <PolicyTextConnected name={PolicyName.GROUP_CONSENT} languageCode={languageCode}>
            {
              ({ summary }) => (
                <BackpackThemeMarkdown text={summary} />
              )
            }
          </PolicyTextConnected>
        </Subheading>

        <Spacer size="10">
          <Subheading>
            <LegalDocumentLinks.GroupConsent className="font-color-backpack-theme-accent">
              <FormattedMessage id="groupJoinConsent.fullConsent.button.label" />
            </LegalDocumentLinks.GroupConsent>
          </Subheading>
        </Spacer>
      </div>
    );
  }
}

export default injectIntl(GroupConsentText);
